import React from 'react';
import {BooleanField, Datagrid, Filter, List, NumberField, TextField, TextInput} from 'react-admin';
import {DateTimeField} from "../../components";

const SettingFilter = (props) => (
    <Filter {...props}>
        <TextInput label="ra.action.search" source="q" alwaysOn/>
    </Filter>
);

export const SettingList = props => (
    <List filters={<SettingFilter/>} {...props} exporter={false} actions={<></>} bulkActions={false}>
        <Datagrid rowClick="edit">
            <TextField source="id"  style={{width: 50}}/>
            <TextField source="category" style={{width: 120}}/>
            <TextField source="name" style={{width: 200}}/>
            <TextField source="description" style={{width: 250}}/>
            <TextField source="stringValue" style={{width: 250, textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}
                       helperText={"Chỉ hiển thị 10 ký tự đầu nếu được mã hoá"}/>
            <NumberField source="intValue"/>
            <BooleanField source="boolValue"/>
            <BooleanField source="encrypted"/>
            <TextField source="lastUpdatedBy" style={{width: 100, textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}/>
            <DateTimeField source='lastUpdatedOn' format="DD-MM-YYYY HH:mm" width={100}/>
        </Datagrid>
    </List>
);

export default SettingList
